export default {
  error_messages: {
    failed_to_fetch_orders:
      'Tietojen lataaminen epäonnistui. Napsauta ”päivitä”-kuvaketta tai yritä uudelleen minuutin kuluttua.',
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen.',
  },
};
